import type { ReactNode } from 'react';
import { PeoplePage } from '../components/people/PeoplePage';

/**
 * USER-03 at `/admin/invite` (the palette's "Invite a person"): People, with the invite form open in the pane
 * beside the list rather than on a page of its own (Admin redesign 2026-11-02, People A). Closing it leaves the
 * Admin on People at `/admin/users`.
 */
export function InviteUserPage(): ReactNode {
  return <PeoplePage isInviteRoute />;
}
